import { Locale } from "date-fns/locale";
import { EventWithOccurrences, type AssetImage } from "gql/generated";
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
} from "react";
import { MultilingualLangKey } from "shared/types";
import { EventWidgetSize } from "widgets/events/types";
import {
  EventsWidgetDetailsDisplayMode,
  EventsWidgetListDisplayMode,
} from "widgets/events/EventsWidget";

export type EventsWidgetContextValues = {
  organizationId: string;
  widgetId?: string; // For widgets created from the widget builder in Whereaabouts
  lang: MultilingualLangKey;
  locale: Locale | undefined;
  widgetDisplayMode?: EventsWidgetListDisplayMode;
  hideFilters?: boolean;
  ignoreImageTextAndNeverBlur?: boolean;
  applyFilters?: string[];
  nextNMonths?: number;
  eventDetailsLink?: string;
  eventDetailsDisplayMode?: EventsWidgetDetailsDisplayMode;
  moreEventsLink?: string;
  hideCarouselScrollbar?: boolean;
  widgetSize: EventWidgetSize;
  widgetHeaderSize: EventWidgetSize;
  selectedEvent: EventWithOccurrences | undefined | null;
  setSelectedEventId: Dispatch<SetStateAction<string | null>>;
  viewOnly?: boolean;
  /** Hero when an event has no images; follows Widget Settings listing fallback (custom / org logo). */
  listingHeroFallbackImage?: Partial<AssetImage> | null;
};

export type EventsWidgetContextProps = Omit<
  EventsWidgetContextValues,
  "locale" | "selectedEventId" | "setSelectedEventId" | "selectedEvent"
> &
  PropsWithChildren;

export const EventsWidgetContext =
  createContext<EventsWidgetContextValues | null>(null);
